"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIToggleGroup = _interopRequireDefault(require("UIComponents/input/UIToggleGroup"));

var PlanType = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/pricings/PlanType"));

var _PropTypes = require("../../../../constants/PropTypes");

var StorefrontCollection = _interopRequireWildcard(require("../../../../constants/StorefrontCollection"));

var _i18n = require("../../../../utils/i18n");

var _RadioInput = _interopRequireDefault(require("../inputs/RadioInput"));

var ALL = 'all';
var pricingValues = [ALL, PlanType.FREE, PlanType.MONTHLY, PlanType.YEARLY, PlanType.ONE_TIME];

var _getPlanTypeFilterI18nKey = function _getPlanTypeFilterI18nKey(value) {
  switch (value) {
    case ALL:
      return 'appMarketplace.storefront.filters.planType.items.all';

    default:
      return (0, _i18n.getPlanTypeFilterI18nKey)(value);
  }
};

var PriceToggleGroup = function PriceToggleGroup(_ref) {
  var activeCollection = _ref.activeCollection,
      _onChange = _ref.onChange,
      inputValue = _ref.value;
  var freeCollectionIsActive = activeCollection === StorefrontCollection.FREE;
  return _react.default.createElement(_UIToggleGroup.default, {
    name: "price"
  }, pricingValues.map(function (pricing) {
    var checked;

    if (freeCollectionIsActive) {
      checked = pricing === PlanType.FREE;
    } else {
      checked = inputValue ? pricing === inputValue : pricing === ALL;
    }

    return _react.default.createElement(_RadioInput.default, {
      key: pricing,
      checked: checked,
      disabled: freeCollectionIsActive,
      onChange: function onChange(_ref2) {
        var value = _ref2.target.value;
        return _onChange(value === ALL ? null : value);
      },
      value: pricing
    }, _react.default.createElement(_FormattedMessage.default, {
      message: _getPlanTypeFilterI18nKey(pricing)
    }));
  }));
};

PriceToggleGroup.propTypes = {
  activeCollection: _PropTypes.storefrontCollection,
  onChange: _propTypes.default.func.isRequired,
  value: _propTypes.default.oneOf(pricingValues)
};
var _default = PriceToggleGroup;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/sidebar/filters/PriceToggleGroup.js
// module id = 717
// module chunks = 209 210 211 212